require("!!D:\\buildAgent\\workDir\\eec88466c176b607\\portal\\node_modules\\script-loader\\addScript.js")(require("!!D:\\buildAgent\\workDir\\eec88466c176b607\\portal\\node_modules\\raw-loader\\index.js!D:\\buildAgent\\workDir\\eec88466c176b607\\portal\\node_modules\\ace-builds\\src-noconflict\\mode-coffee.js"))


//////////////////
// WEBPACK FOOTER
// ./~/ace-builds/src-noconflict/mode-coffee.js
// module id = 862407532959746
// module chunks = 0